import { useSurfaces } from 'pages/surface/hooks/use-surfaces';
import { useSurfaceState } from 'pages/surface/store/hooks/surface';
import { ParametersEnum } from '../types';
import { useFilteredInputParams } from '../forms/hooks/use-filtered-input-params';

export const doorsWindowsInputs = [ParametersEnum.doors, ParametersEnum.windows];

export const useFormConditions = () => {
  const surfaces = useSurfaces();
  const { surfaceFormState } = useSurfaceState();
  const { inputParameters } = useFilteredInputParams();

  const hasDoorsWindows = inputParameters.some(param => doorsWindowsInputs.includes(param));
  const hasThickness = surfaces
    .filter(surf => surfaceFormState[surf.name])
    .some(surface => !!surface.typeInstallation);
  const hasMaterialsHeader =
    Object.keys(surfaces[0].materials).length > 1 || Object.keys(surfaces).length > 1;
  const hasDoors = inputParameters.includes(ParametersEnum.doors);
  const hasWindows = inputParameters.includes(ParametersEnum.windows);

  return {
    hasDoorsWindows,
    hasThickness,
    hasMaterialsHeader,
    hasDoors,
    hasWindows,
  };
};
